import { useEffect, useState } from 'react';
import { useAppSelector } from './reduxHook';
import useGetOrCreateMidTermAdjustment from '../models/midTermAdjustment-model';
import { MtaChangeType } from '../services/api';

const useTopUpMilesData = () => {
	const [loading, setLoading] = useState(false);
	const mtaChanges = useAppSelector((redux) => redux.midTermAdjustment);
	const lists = useAppSelector((redux) => redux.referenceData);

	const { midTermAdjustment } = useGetOrCreateMidTermAdjustment({
		changeType: MtaChangeType.TOP_UP_MILES,
		setAdjustmentLoading: setLoading,
	});

	// Set loading when change of usage occurs
	useEffect(() => {
		if (mtaChanges.changeOfUsage) {
			setLoading(true);
		}
	}, [mtaChanges.changeOfUsage]);

	return { loading, setLoading, midTermAdjustment, lists };
};

export default useTopUpMilesData;
